module.exports = __webpack_public_path__ + "static/media/delete_orange.05d3a76d.svg";